import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'lib-success-toast-icon',
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      [attr.fill]="fill()"
      [style.color]="color()"
      [class]="iconClass()">
      <path
        d="M16.0001 2.66667C8.65341 2.66667 2.66675 8.65334 2.66675 16C2.66675 23.3467 8.65341 29.3333 16.0001 29.3333C23.3467 29.3333 29.3334 23.3467 29.3334 16C29.3334 8.65334 23.3467 2.66667 16.0001 2.66667ZM22.3734 12.9333L14.8134 20.4933C14.6267 20.68 14.3734 20.7867 14.1067 20.7867C13.8401 20.7867 13.5867 20.68 13.4001 20.4933L9.62675 16.72C9.24008 16.3333 9.24008 15.6933 9.62675 15.3067C10.0134 14.92 10.6534 14.92 11.0401 15.3067L14.1067 18.3733L20.9601 11.52C21.3467 11.1333 21.9867 11.1333 22.3734 11.52C22.7601 11.9067 22.7601 12.5333 22.3734 12.9333Z"
        [attr.fill]="color() === 'currentColor' ? '#22C55E' : color()" />
    </svg>
  `,
})
export class SuccessToastIconComponent extends BaseIconComponent {
  override width = input<string>('2rem');
  override height = input<string>('2rem');
  override viewBox = input<string>('0 0 32 32');
  override fill = input<string>('none');
  override color = input<string>('currentColor');
}
